<template>
  <div class="shops-detail-order">
    <page-title title="商品信息">
      <ul class="detail-order-info">
        <li class="info-item">
          <img src="@/assets/images/shop/icon-smile.png" />
          <div class="data-wrapper">
            <span>商品总数量</span>
            <p @click="$router.push({ path: '/goodsReviewed', query: { shopId: $route.params.id, type: '' } })">
              <span>{{ shopStatistics.spuCounts }}</span>
              查看
            </p>
          </div>
        </li>
        <li class="info-item">
          <img src="@/assets/images/shop/icon-smile.png" />
          <div class="data-wrapper">
            <span>出售中</span>
            <p @click="$router.push({ path: '/goodsReviewed', query: { shopId: $route.params.id, type: 'ON_SALE' } })">
              <span>{{ shopStatistics.spuOnSales }}</span>
              查看
            </p>
          </div>
        </li>
        <li class="info-item">
          <img src="@/assets/images/shop/icon-smile.png" />
          <div class="data-wrapper">
            <span>审核中</span>
            <p @click="$router.push({ path: '/goodsNotReviewed', query: { shopId: $route.params.id } })">
              <span>{{ shopStatistics.spuChecks }}</span>
              查看
            </p>
          </div>
        </li>
        <li class="info-item">
          <img src="@/assets/images/shop/icon-smile.png" />
          <div class="data-wrapper">
            <span>仓库中</span>
            <p @click="$router.push({ path: '/goodsReviewed', query: { shopId: $route.params.id, type: 'RESERVE' } })">
              <span>{{ shopStatistics.spuReserves }}</span>
              查看
            </p>
          </div>
        </li>
        <li class="info-item">
          <img src="@/assets/images/shop/icon-smile.png" />
          <div class="data-wrapper">
            <span>违规下架</span>
            <p
              @click="
                $router.push({
                  path: '/goodsReviewed',
                  query: { shopId: $route.params.id, type: 'VIOLATION_HALT_SALE' }
                })
              "
            >
              <span>{{ shopStatistics.spuViolations }}</span>
              查看
            </p>
          </div>
        </li>
      </ul>
    </page-title>
    <page-title title="订单信息">
      <ul class="detail-order-list">
        <li class="order-list-item">
          <div class="img-wrapper">
            <img src="@/assets/images/homeIcon/icon-data.png" />
          </div>
          <div class="data-wrapper">
            <span>订单总数量</span>
            <p @click="$router.push({ path: '/order', query: { shopId: $route.params.id, type: '' } })">
              <span class="black">{{ shopStatistics.orderCounts }}</span>
              查看
            </p>
          </div>
        </li>
        <li class="order-list-item">
          <div class="img-wrapper">
            <img src="@/assets/images/homeIcon/icon-data.png" />
          </div>
          <div class="data-wrapper">
            <span>待买家付款</span>
            <p @click="$router.push({ path: '/order', query: { shopId: $route.params.id, type: 'TOPAY' } })">
              <span class="black">{{ shopStatistics.orderToPays }}</span>
              查看
            </p>
          </div>
        </li>
        <li class="order-list-item">
          <div class="img-wrapper">
            <img src="@/assets/images/homeIcon/icon-data.png" />
          </div>
          <div class="data-wrapper">
            <span>等待发货</span>
            <p @click="$router.push({ path: '/order', query: { shopId: $route.params.id, type: 'TOSHIP' } })">
              <span class="black">{{ shopStatistics.orderToShips }}</span>
              查看
            </p>
          </div>
        </li>
        <li class="order-list-item">
          <div class="img-wrapper">
            <img src="@/assets/images/homeIcon/icon-data.png" />
          </div>
          <div class="data-wrapper">
            <span>已发货</span>
            <p @click="$router.push({ path: '/order', query: { shopId: $route.params.id, type: 'SHIPPED' } })">
              <span class="black">{{ shopStatistics.orderShips }}</span>
              查看
            </p>
          </div>
        </li>
        <li class="order-list-item">
          <div class="img-wrapper">
            <img src="@/assets/images/homeIcon/icon-data.png" />
          </div>
          <div class="data-wrapper">
            <span>已退款</span>
            <p @click="$router.push({ path: '/refund', query: { shopId: $route.params.id, type: '',orderItemStatus: 'REFUNDED' } })">
              <span class="black">{{ shopStatistics.orderRefunds }}</span>
              查看
            </p>
          </div>
        </li>
        <li class="order-list-item">
          <div class="img-wrapper">
            <img src="@/assets/images/homeIcon/icon-data.png" />
          </div>
          <div class="data-wrapper">
            <span>成功的订单</span>
            <p @click="$router.push({ path: '/order', query: { shopId: $route.params.id, type: 'CONFIRMED' } })">
              <span class="black">{{ shopStatistics.orderSuccess }}</span>
              查看
            </p>
          </div>
        </li>
        <li class="order-list-item">
          <div class="img-wrapper">
            <img src="@/assets/images/homeIcon/icon-data.png" />
          </div>
          <div class="data-wrapper">
            <span>关闭的订单</span>
            <p @click="$router.push({ path: '/order', query: { shopId: $route.params.id, type: 'CANCELED' } })">
              <span class="black">{{ shopStatistics.orderCloses }}</span>
              查看
            </p>
          </div>
        </li>
      </ul>
    </page-title>
    <page-title title="资金信息">
      <div class="funds-list">
        <funds-panel type="1" :data="shopStatistics.accountBalance"></funds-panel>
        <funds-panel type="2" :data="shopStatistics.withdrawalInProgress"></funds-panel>
        <funds-panel type="3" :data="shopStatistics.unrecorded"></funds-panel>
        <funds-panel type="4" :data="shopStatistics.withDrawableCash"></funds-panel>
        <!-- <funds-panel type="1" :data="shopAssets.balance"></funds-panel>
        <funds-panel type="2" :data="shopAssets.balancing"></funds-panel>
        <funds-panel type="3" :data="shopAssets.unBalance"></funds-panel>
        <funds-panel type="4" :data="shopAssets.withBalance"></funds-panel> -->
      </div>
    </page-title>
  </div>
</template>

<script>
import pageTitle from '@/components/pageTitle.vue';
import FundsPanel from '@/views/shop/components/fundsPanel';
export default {
  props: {
    shopStatistics: Object,
    // shopAssets: Object
  },
  components: { pageTitle, FundsPanel },
  name: 'shopDetailOrder'
};
</script>

<style lang="scss">
.shops-detail-order {
  ul,
  li {
    list-style: none;
  }
  .detail-order-info {
    display: flex;
    .info-item {
      flex: 1;
      border-radius: 4px;
      height: 60px;
      background: url('../../../assets/images/shop/bg-info.png');
      background-repeat: no-repeat;
      background-size: cover;
      margin-right: 16px;
      padding: 20px 26px;
      display: flex;
      &:last-of-type {
        margin-right: 0;
      }
      img {
        padding: 15px;
        height: 30px;
        width: 30px;
        background-color: white;
        border-radius: 50%;
      }
    }
  }
  .detail-order-list {
    display: flex;
    .order-list-item {
      flex: 1;
      display: flex;
      &:not(:last-child) {
        border-right: 1px solid #eee;
        margin-right: 20px;
      }
      .img-wrapper {
        padding: 20px;
        border-radius: 50%;
        background-color: #005bff;
        height: 24px;
        width: 24px;
        display: inline-block;
        img {
          height: 24px;
          width: 24px;
          object-fit: cover;
        }
      }
    }
  }
  .data-wrapper {
    flex: 1;
    padding: 3px 20px;
    font-size: 14px;
    color: #8998a0;
    line-height: 26px;
    overflow: hidden;
    min-width: 110px;
    p {
      color: #005bff;
      font-weight: bold;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      span {
        font-size: 20px;
        margin-right: 4px;
      }
      .black {
        color: black;
      }
    }
  }
  .funds-list {
    display: flex;
  }
  .shop-funds-panel__wrapper {
    flex: 1;
  }
}
</style>
